import { sizeStyles, tagTextStyles, defaultIconTypes } from './constants.js';
import { InlineChildren, Text, Icon } from '@doordash/design-language';
import { getPropsToForward } from '@doordash/utilities';
import React from 'react';
import { TagWrapper, IconButtonWrapper, IconWrapper } from './styles.js';
import { TagSize, TagType, IconTypes } from './types.js';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TagIcon = function TagIcon(_ref) {
  var accessibilityLabel = _ref.accessibilityLabel,
      onClick = _ref.onClick,
      size = _ref.size,
      type = _ref.type,
      tagType = _ref.tagType,
      _ref$useDefaultColors = _ref.useDefaultColors,
      useDefaultColors = _ref$useDefaultColors === void 0 ? false : _ref$useDefaultColors;
  var iconType = type || defaultIconTypes[tagType];
  var iconComponent = /*#__PURE__*/React.createElement(Icon, {
    shouldAdjustSmallSizesWhitespace: true,
    color: Icon.Colors["Tag".concat(tagType, "Icon")],
    size: sizeStyles[size].iconSize,
    type: Icon.Types[iconType],
    useDefaultColors: useDefaultColors
  });

  if (onClick) {
    return /*#__PURE__*/React.createElement(IconButtonWrapper, {
      "aria-label": accessibilityLabel,
      onClick: onClick
    }, iconComponent);
  }

  return /*#__PURE__*/React.createElement(IconWrapper, null, iconComponent);
};

var Tag = function Tag(_ref2) {
  var text = _ref2.text,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? Tag.Types.InformationalDefault : _ref2$type,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? Tag.Sizes.Small : _ref2$size,
      _ref2$hasLeadingIcon = _ref2.hasLeadingIcon,
      hasLeadingIconProp = _ref2$hasLeadingIcon === void 0 ? false : _ref2$hasLeadingIcon,
      _ref2$hasTrailingIcon = _ref2.hasTrailingIcon,
      hasTrailingIconProp = _ref2$hasTrailingIcon === void 0 ? false : _ref2$hasTrailingIcon,
      leadingIconAccessibilityLabel = _ref2.leadingIconAccessibilityLabel,
      leadingIconType = _ref2.leadingIconType,
      onLeadingClick = _ref2.onLeadingClick,
      onTrailingClick = _ref2.onTrailingClick,
      textProps = _ref2.textProps,
      trailingIconAccessibilityLabel = _ref2.trailingIconAccessibilityLabel,
      trailingIconType = _ref2.trailingIconType,
      _ref2$trailingIcon = _ref2.trailingIcon,
      trailingIcon = _ref2$trailingIcon === void 0 ? false : _ref2$trailingIcon,
      _ref2$leadingIcon = _ref2.leadingIcon,
      leadingIcon = _ref2$leadingIcon === void 0 ? false : _ref2$leadingIcon,
      props = _objectWithoutProperties(_ref2, ["text", "type", "size", "hasLeadingIcon", "hasTrailingIcon", "leadingIconAccessibilityLabel", "leadingIconType", "onLeadingClick", "onTrailingClick", "textProps", "trailingIconAccessibilityLabel", "trailingIconType", "trailingIcon", "leadingIcon"]);

  if (hasLeadingIconProp && typeof onLeadingClick !== 'undefined' && !leadingIconAccessibilityLabel) {
    throw new Error('You MUST define leadingIconAccessibilityLabel if you are passing a callback to onLeadingClick');
  }

  if (hasTrailingIconProp && typeof onTrailingClick !== 'undefined' && !trailingIconAccessibilityLabel) {
    throw new Error('You MUST define trailingIconAccessibilityLabel if you are passing a callback to onTrailingClick');
  }

  if (leadingIconAccessibilityLabel || leadingIconType || onLeadingClick || onTrailingClick || trailingIconAccessibilityLabel || trailingIconType || hasLeadingIconProp || hasTrailingIconProp) {
    if (process.env.NODE_ENV === 'development') {
      console.warn("Using a legacy leading / trailing IconProp (leadingIconAccessibilityLabel, leadingIconType, onTrailingClick, trailingIconAccessibilityLabel, trailingIconType) for the Tag Component is no longer recommended. You'll have a better experience moving those properties into the trailingIcon or leadingIcon prop. We'll be removing legacy tag icon props in a future version.");
    }
  }

  if (typeof trailingIcon !== 'boolean' && trailingIcon !== null && trailingIcon !== void 0 && trailingIcon.onClick && !(trailingIcon !== null && trailingIcon !== void 0 && trailingIcon.accessibilityLabel)) {
    throw new Error('You MUST define trailingIconProps.accessibilityLabel if you are passing a callback to trailingIconProps.onClick');
  }

  if (typeof leadingIcon !== 'boolean' && leadingIcon !== null && leadingIcon !== void 0 && leadingIcon.onClick && !(leadingIcon !== null && leadingIcon !== void 0 && leadingIcon.accessibilityLabel)) {
    throw new Error('You MUST define leadingIconProps.accessibilityLabel if you are passing a callback to leadingIconProps.onClick');
  }

  var propsToForward = getPropsToForward({
    props: props,
    prefixesToForward: ['data-', 'aria-']
  });

  var hasIcon = function hasIcon(iconProp) {
    if (typeof iconProp === 'boolean') {
      return iconProp;
    }

    if (_typeof(iconProp) !== 'object') return false; //return true if iconProp is an object and at least one of the props is present.
    //if iconProp === {}, this returns false.

    var iconProperties = ['type', 'accessibilityLabel', 'useDefaultColors', 'onClick'];
    return Object.keys(iconProp).some(function (prop) {
      return iconProperties.includes(prop);
    }); //returns true if the object contains any relevant properties
  };

  var hasLeadingIcon = hasLeadingIconProp || hasIcon(leadingIcon);
  var hasTrailingIcon = hasTrailingIconProp || hasIcon(trailingIcon);
  return /*#__PURE__*/React.createElement(TagWrapper, _extends({
    backgroundColor: "Tag".concat(type, "Background"),
    borderColor: "Tag".concat(type, "Border"),
    hasLeadingIcon: hasLeadingIcon,
    hasTrailingIcon: hasTrailingIcon,
    size: size
  }, propsToForward), /*#__PURE__*/React.createElement(InlineChildren, {
    alignItems: InlineChildren.Alignment.Center,
    justifyContent: InlineChildren.Justification.Center,
    size: InlineChildren.Sizes[sizeStyles[size].inlineChildrenSize]
  }, hasLeadingIcon && /*#__PURE__*/React.createElement(TagIcon, _extends({
    accessibilityLabel: leadingIconAccessibilityLabel,
    type: leadingIconType,
    onClick: onLeadingClick,
    size: size,
    tagType: type
  }, typeof leadingIcon !== 'boolean' && leadingIcon)), /*#__PURE__*/React.createElement(Text, _extends({
    color: Text.Colors["Tag".concat(type, "Foreground")],
    styles: Text.Styles[tagTextStyles[size]],
    overflow: Text.Overflows.Truncate
  }, textProps), text), hasTrailingIcon && /*#__PURE__*/React.createElement(TagIcon, _extends({
    accessibilityLabel: trailingIconAccessibilityLabel,
    type: trailingIconType,
    onClick: onTrailingClick,
    size: size,
    tagType: type
  }, typeof trailingIcon !== 'boolean' && trailingIcon))));
};

Tag.Sizes = TagSize;
Tag.Types = TagType;
Tag.IconTypes = IconTypes;
Tag.defaultProps = {
  hasLeadingIcon: false,
  hasTrailingIcon: false,
  size: Tag.Sizes.Small,
  type: Tag.Types.InformationalDefault
};

export { TagIcon, Tag as default };
